// authProvider.js
import { PublicClientApplication } from "@azure/msal-browser"
import { getConfiguration, IConfiguration } from "./config"

let pca: PublicClientApplication

export const getPca = () => {
  if (pca) {
    return pca
  } else {
    const config = getConfiguration()
    pca = new PublicClientApplication(config.B2C_CONFIGURATION)
    return pca
  }
}
